import { Box, Text, colors, dimensions } from '@factorialco/deprecated-design-system'

import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

const Tip = ({ href, textLink }: { href: string; textLink: string }) => {
  return (
    <a
      style={{ color: colors.viridian800, textDecoration: 'none' }}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {textLink}
    </a>
  )
}

const ContractTips = () => {
  const tips = [
    i18n.tView('import_contract.tips.before_importing', {
      link: (
        <Tip
          href={helpCenterUrl('contracts-in-factorial')}
          textLink={i18n.t('import_contract.tips.configure')}
        />
      ),
    }),
    i18n.tView('import_contract.tips.import_or_update_how_to', {
      link: (
        <Tip
          href={helpCenterUrl('import_contracts')}
          textLink={i18n.t('import_contract.tips.how_to_import')}
        />
      ),
    }),
    i18n.t('import_contract.tips.large_file'),
  ]

  return (
    <Box
      background="viridian100"
      paddingY="s24"
      paddingX="s16"
      borderRadius={{
        all: 'abs008',
      }}
    >
      <Text.Normal weight="medium">{i18n.t('import_contract.tips.title')}</Text.Normal>
      <Box paddingTop="s16" paddingX="s16">
        <ul style={{ listStyle: 'disc' }}>
          {tips.map((tip, index) => (
            <li style={{ marginBottom: dimensions.s12 }} key={index}>
              {tip}
            </li>
          ))}
        </ul>
      </Box>
    </Box>
  )
}

export default ContractTips
